export default "__VITE_PUBLIC_ASSET__157030e4__"